import React from "react";
import { Dialog } from "@mui/material";

import AButton from "views/pages/manage/common/form-fields-mui/AButton";

const DiscardDialog = ({ facultyId, isOpen, onReject, onConfirm }) => {
  return (
    <Dialog open={isOpen} fullWidth size="md">
      <div className="p-4 confirm-rejection-dialog">
        <div className="d-flex justify-content-between">
          <div style={{ margin: "auto" }}>
            <div
              style={{
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "24px",
                textAlign: "center",
              }}
            >
              Employee ID "{facultyId}" is not present in HONO. Proceed with
              creating a manual entry?
            </div>
          </div>
          {/* <CrossIcon onClick={closeDialog} /> */}
        </div>
        <div className="d-flex justify-content-center mt-4">
          <AButton variant="primary_filled" onClick={onConfirm}>
            Yes
          </AButton>

          <AButton
            className="reject-btn px-5"
            variant="danger_filled"
            onClick={onReject}
            // style={{ width: "max-content" }}
          >
            No
          </AButton>
        </div>
      </div>
    </Dialog>
  );
};

export default DiscardDialog;
